import React from 'react'
import { intl } from 'lang/intl'

import { useActiveActionCardsQuery } from '../blocs/useActionCards'

import './ActionCardHeader.scss'

const ActionCardHeader = () => {
  const { data: card } = useActiveActionCardsQuery()

  if (!card || !card.isActive) {
    return null
  }

  return (
    <>
      {card.title && <div className="action-card-title">{card.title}</div>}
      <div className="action-card-header-desc-image-container">
        {card.imageUrl && (
          <img
            className="action-card-audience-image"
            src={card.imageUrl}
            alt={intl.formatMessage({
              defaultMessage: 'Action Card Thumbnail',
            })}
          />
        )}
      </div>
      {card.description && (
        <div className="action-card-description">{card.description}</div>
      )}
    </>
  )
}

export { ActionCardHeader }
